import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

const MButton = ({ children, color, css, style, onClick, circle = false, disabled = false, height }) => {
  const [btnStyle, setBtnStyle] = useState(style || {});
  
  useEffect(() => {
    const _style = { ...style };
    if (circle) {
      _style.borderRadius = 300;
    }
    if (height && height > 0) {
      _style.height = height;
    }
    setBtnStyle(_style);
  }, [style, circle, height]);
  return <>
    <Button 
      variant={color || "primary-500"} 
      className={css} 
      style={btnStyle} 
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  </>
};

const mapState = (state) => {
  const avatarId = state.AvatarReducer.id;
  const avatarItem = state.AvatarReducer.item;
  const pageTitle = state.AppReducer.pageTitle;
  return { pageTitle, avatarId, avatarItem };
};

const mapDispatch = dispatch => ({
  // CheckAvatarId: (id, region) => dispatch(AvatarAction.CheckAvatarId(id, region)),
});

export default connect(mapState, mapDispatch)(MButton);
